/**
 * A sign-in while this PCA is already online (another tab, browser or device)
 * joins that live session. It must not switch them to Not Accepting or zero
 * their open-chat count: every tab follows doctors/{uid}/accepting_chat, so the
 * reset flipped the PCA to Not Accepting mid-chat with no action from them.
 * A sign-in from offline starts Not Accepting.
 *
 * Caveat: doctors/{uid}/online is never cleared on tab close (no onDisconnect)
 * and router.js sets it on load, so a PCA who closed the browser while Accepting
 * counts as "already online" and comes back Accepting, with the old
 * activeOnlineChats. The router write also usually lands before the sign-in
 * reads it, so even a clean sign-in looks like a join. Real presence: #63.
 */
export const joinsLiveSession = (doctor) => doctor?.online === true;
